import { useState } from "react";
import {
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  Menu,
  MenuItem,
  Box,
  Typography,
  Divider,
} from "@mui/material";
// import {
//   Dashboard,
//   Business,
//   ShoppingCart,
//   AccountBalance,
//   People,
//   BarChart,
//   Settings,
//   ChevronRight,
//   ArrowBack,
// } from "@mui/icons-material";
import {
  ChevronRight,
  ArrowBack,
  Dashboard,
  Business,
  ShoppingCart,
  AccountBalance,
  People,
  BarChart,
  KeyboardArrowDown,
  KeyboardArrowRight,
  Settings,
  AccountTree,
  Inventory2,
  Savings,
  MoreHoriz,
  BalanceOutlined,
  CategoryOutlined,
  LabelOutlined,
  Assignment,
  LocalShipping,
  AssignmentReturn,
  Summarize,
  ReceiptLong,
  PersonSearch,
  ViewList,
  RequestQuote,
  ShoppingBag,
  Undo,
  BarChartOutlined,
  GroupWork,
  PeopleAlt,
  ListAlt,
  Add,
  TableChart,
  MoveToInbox,
  Outbox,
  CompareArrows,
  Timeline,
  Receipt,
  PrecisionManufacturing,
  CardGiftcard,
  Build,
  SwapHoriz,
  CalendarMonth,
} from "@mui/icons-material";

import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const MobileBottomNav = () => {
  const history = useHistory();
  const location = useLocation();
  const { permissions, roleName } = useAuth();

  const isExecutiveRole = (roleName || '').toLowerCase().includes('executive');

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [transactionSubMenu, setTransactionSubMenu] = useState(null); // 'purchase' or 'sales'
  const [productSubMenu, setProductSubMenu] = useState(false); // For Product submenu
  const [accountMasterSubMenu, setAccountMasterSubMenu] = useState(false); // For Account Master submenu
  const [masterSubMenu, setMasterSubMenu] = useState(false); // For Master (Client/Vendor) submenu
  const hasReadMasterPermission = permissions.includes('Read Master');
  const hasReadAccountsPermission = permissions.includes('Read Accounts');
  const hasReadAdministrationPermission = permissions.includes('Read Administration');
  const hasReadReportsPermission = permissions.includes('Read Reports');

  const handleMenuOpen = (event, menuId) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(menuId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveMenu(null);
    setTransactionSubMenu(null);
    setProductSubMenu(false);
    setAccountMasterSubMenu(false);
    setMasterSubMenu(false);
  };

  const handleNavigation = (path) => {
    history.push(path);
    handleMenuClose();
  };

  const menuItems = {
    accountMaster: [
      { label: 'Account Head', route: '/AccountHeadIndex', icon: <AccountTree sx={{ fontSize: 15 }} /> },
      { label: 'Asset', route: '/AssetIndex', icon: <Inventory2 sx={{ fontSize: 15 }} /> },
      { label: 'Capital', route: '/CapitalIndex', icon: <Savings sx={{ fontSize: 15 }} /> },
      { label: 'Others', route: '/OtherOptionIndex', icon: <MoreHoriz sx={{ fontSize: 15 }} /> },
      // { label: 'Sales Executive', route: '/SalesExecutiveIndex', icon: <PeopleAlt sx={{ fontSize: 15 }} /> },
      // { label: 'Executive Dashboard', route: '/SalesExecutiveDashboard', icon: <Dashboard sx={{ fontSize: 15 }} /> },
      { label: 'Balance Sheet', route: '/BalanceSheetHeadIndex', icon: <BalanceOutlined sx={{ fontSize: 15 }} /> },
    ],
    master: [
      { label: 'Account Master', isNested: true, subMenuKey: 'accountMaster', icon: <AccountTree sx={{ fontSize: 15 }} /> },
      { label: 'Bank', route: '/BankIndex', icon: <AccountBalance sx={{ fontSize: 15 }} /> },
      { label: 'Company', route: '/CompanyEdit', icon: <Business sx={{ fontSize: 15 }} /> },
      { label: 'Master', isNested: true, subMenuKey: 'masterSub', icon: <People sx={{ fontSize: 15 }} /> },
      { label: 'Product', isNested: true, subMenuKey: 'product', icon: <Inventory2 sx={{ fontSize: 15 }} /> },
    ],
    masterSub: [
      { label: 'Client', route: '/ClientIndex', icon: <People sx={{ fontSize: 15 }} /> },
      { label: 'Vendor', route: '/VendorIndex', icon: <Business sx={{ fontSize: 15 }} /> },
    ],
    product: [
      { label: 'Category', route: '/ProductCategoryIndex', icon: <CategoryOutlined sx={{ fontSize: 15 }} /> },
      { label: 'Sub-Category', route: '/ProductSubCategoryIndex', icon: <CategoryOutlined sx={{ fontSize: 15 }} /> },
      { label: 'Brand', route: '/ProductBrandIndex', icon: <LabelOutlined sx={{ fontSize: 15 }} /> },
      { label: 'Item', route: '/ProductItemIndex', icon: <Inventory2 sx={{ fontSize: 15 }} /> },
    ],
    transaction: {
      purchase: {
        entries: [
          { label: 'Purchase Order', route: '/PurchaseOrderIndex', icon: <Assignment sx={{ fontSize: 15 }} /> },
          { label: 'Purchase', route: '/PurchaseIndex', icon: <LocalShipping sx={{ fontSize: 15 }} /> },
          { label: 'Purchase Return', route: '/PurchaseReturnAgainstIndex', icon: <AssignmentReturn sx={{ fontSize: 15 }} /> },
        ],
        reports: [
          { label: 'Purchase Report', route: '/PurchaseReport', icon: <Summarize sx={{ fontSize: 15 }} /> },
          { label: 'PO Status Report', route: '/PurchaseOrderStatusReport', icon: <ReceiptLong sx={{ fontSize: 15 }} /> },
          { label: 'Vendor & Item Wise', route: '/VendorandItemWisePurchaseReport', icon: <PersonSearch sx={{ fontSize: 15 }} /> },
          // { label: 'Vendor Ageing', route: '/VendorAgeingReport', icon: <ReceiptLong sx={{ fontSize: 15 }} /> },
          { label: 'Purchase Register', route: '/PurchaseRegister', icon: <BarChart sx={{ fontSize: 15 }} /> },
        ],
      },
      sales: {
        entries: [
          { label: 'Enquiry', route: '/EnquiryIndex', icon: <Assignment sx={{ fontSize: 15 }} /> },
          { label: 'Schemes', route: '/SchemeIndex', icon: <CardGiftcard sx={{ fontSize: 15 }} /> },
          { label: 'Quotation', route: '/QuotationIndex', icon: <RequestQuote sx={{ fontSize: 15 }} /> },
          { label: 'Sales Order', route: '/SaleOrderIndex', icon: <Assignment sx={{ fontSize: 15 }} /> },
          { label: 'Sales', route: '/SaleIndex', icon: <ShoppingBag sx={{ fontSize: 15 }} /> },
          { label: 'Sales Return', route: '/SalesReturnIndex', icon: <Undo sx={{ fontSize: 15 }} /> },
        ],
        reports: [
          { label: 'Sales Report', route: '/SalesReport', icon: <Summarize sx={{ fontSize: 15 }} /> },
          { label: 'SO Status Report', route: '/SalesOrderReport', icon: <ReceiptLong sx={{ fontSize: 15 }} /> },
          { label: 'Customer & Item Wise', route: '/CustomerWiseSalesReport', icon: <PeopleAlt sx={{ fontSize: 15 }} /> },
          { label: 'Sales Register', route: '/SalesRegister', icon: <BarChart sx={{ fontSize: 15 }} /> },
        ],
      },
      stock: {
        entries: [
          { label: 'Stock Transfer In', route: '/StockTransferInIndex', icon: <MoveToInbox sx={{ fontSize: 15 }} /> },
          { label: 'Stock Transfer Out', route: '/StockTransferOutIndex', icon: <Outbox sx={{ fontSize: 15 }} /> },
        ],
        reports: [
          { label: 'Stock Transfer Report', route: '/StockTransferReport', icon: <CompareArrows sx={{ fontSize: 15 }} /> },
          { label: 'Stock Movement Report', route: '/StockMovementReport', icon: <Timeline sx={{ fontSize: 15 }} /> },
        ],
      },
      production: {
        entries: [
          { label: 'Production', route: '/ProductionIndex', icon: <PrecisionManufacturing sx={{ fontSize: 15 }} /> },
        ],
      },
    },
    einvoice: [
      { label: 'E-Invoice', route: '/EInvoiceIndex', icon: <Receipt sx={{ fontSize: 15 }} /> },
    ],
    accounts: [
      { label: 'Payment & Receipt', route: '/PaymentAndReceiptIndex', icon: <AccountBalance sx={{ fontSize: 15 }} /> },
      { label: 'Journal Entry', route: '/JournalEntryIndex', icon: <ReceiptLong sx={{ fontSize: 15 }} /> },
    ],
    reports: [
      { label: 'Ledger', route: '/Ledger' },
      { label: 'CashBook', route: '/CashBook' },
      { label: 'Sale GST Report', route: '/SaleGstReport' },
      { label: 'Outstanding', route: '/Outstanding' },
      { label: 'Expense Report', route: '/ExpenseReport' },
    ],
    delivery: [
      { label: 'Schedules', route: '/Schedules', icon: <CalendarMonth sx={{ fontSize: 15 }} /> },
      { label: 'Installation', route: '/InstallationScheduleList', icon: <Build sx={{ fontSize: 15 }} /> },
      { label: 'Onsite Exchange Item', route: '/OnsiteExchangeList', icon: <SwapHoriz sx={{ fontSize: 15 }} /> },
      { label: 'Cash On Delivery', route: '/CashOnDeliveryList', icon: <LocalShipping sx={{ fontSize: 15 }} /> },
    ],
    deliveryUpdates: [
      { label: 'Onsite Exchange', route: '/ExchangeList', icon: <SwapHoriz sx={{ fontSize: 15 }} /> },
      { label: 'Cash On Delivery', route: '/CODList', icon: <LocalShipping sx={{ fontSize: 15 }} /> },
    ],
    settings: [
      { label: 'Auth Console', route: '/AuthConsole' },
      { label: 'Reset Password', route: '/PasswordChange' },
    ],
  };

  // Helper to check if a route is active
  const isActive = (route) => location.pathname === route || location.pathname.startsWith(route + '/');
  const isAnyActive = (routes) => routes.some(r => isActive(r));

  const isReportsActive = location.pathname === '/ReportsHub' || [
    '/TrialBalanceReport', '/RatioAnalysisReport', '/SchemeSummaryReport',
    '/ProfitLossMonthWise', '/BalanceSheet', '/BalanceSheetTView',
    '/CashFlowStatement', '/FundFlowStatement',
    '/SalesReport', '/SalesOrderReport', '/CustomerWiseSalesReport',
    '/CustomerAgeingReport', '/SalesRegister', '/SalesAnalysis',
    '/PurchaseReport', '/PurchaseOrderStatusReport', '/VendorandItemWisePurchaseReport',
    '/VendorAgeingReport', '/PurchaseRegister',
    '/StockTransferReport', '/StockMovementReport', '/StockSummaryReport',
    '/StockAnalysisReport', '/StockAgeingReport', '/StockDayBook', '/StockLedger',
    '/Ledger', '/CashBook', '/Outstanding', '/IncomeExpenseReport',
    '/ExpenseAdvancedReport', '/DetailedInvoice',
    '/SaleGstReport', '/GSTR3BReport', '/GSTR3BFormatReport',
    '/TaxRegisterSale', '/TaxRegisterPurchase', '/HSNTaxSummary',
    '/DayBookReport', '/DayBookSummaryReport', '/BankBookReport',
    '/DelayedPaymentReport', '/DelayedCollectionReport',
  ].some(r => location.pathname.startsWith(r));

  const isMasterActive = isAnyActive([
    ...menuItems.master.filter(i => i.route).map(i => i.route),
    ...menuItems.masterSub.filter(i => i.route).map(i => i.route),
    ...menuItems.product.filter(i => i.route).map(i => i.route),
    ...menuItems.accountMaster.filter(i => i.route).map(i => i.route),
  ]);

  const isTransactionActive = isAnyActive([
    ...menuItems.transaction.purchase.entries.map(i => i.route),
    ...menuItems.transaction.purchase.reports.map(i => i.route),
    ...menuItems.transaction.sales.entries.map(i => i.route),
    ...menuItems.transaction.sales.reports.map(i => i.route),
    ...menuItems.transaction.stock.entries.map(i => i.route),
    ...menuItems.transaction.stock.reports.map(i => i.route),
    ...menuItems.transaction.production.entries.map(i => i.route),
    ...menuItems.einvoice.map(i => i.route),
  ]);

  const isAccountsActive = isAnyActive(menuItems.accounts.map(i => i.route));
  const isSettingsActive = isAnyActive(menuItems.settings.map(i => i.route));
  const isDeliveryActive = isAnyActive(menuItems.delivery.map(i => i.route));
  const isDeliveryUpdatesActive = isAnyActive(menuItems.deliveryUpdates.map(i => i.route));


  // Active style for menu items
  const menuPaperSx = {
    background: 'linear-gradient(160deg, #1a1f5e 0%, #141852 100%)',
    color: 'white',
    borderRadius: '16px',
    minWidth: '230px',
    maxHeight: '72vh',
    mb: 1,
    border: '1px solid rgba(255,255,255,0.08)',
    boxShadow: '0 -8px 32px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.04)',
    overflow: 'hidden',
  };

  const menuHeaderSx = {
    px: 2, py: 1.2,
    background: 'linear-gradient(90deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.02) 100%)',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    display: 'flex', alignItems: 'center', gap: 1.5,
    cursor: 'pointer',
    '&:hover': { background: 'rgba(255,255,255,0.08) !important' },
  };

  const activeItemSx = (route) => ({
    fontSize: '13.5px', py: 1.2, px: 2,
    display: 'flex', alignItems: 'center', gap: 1.5,
    borderRadius: '8px', mx: 0.8, my: 0.2,
    background: isActive(route) ? 'linear-gradient(90deg, rgba(99,102,241,0.25), rgba(139,92,246,0.15)) !important' : 'transparent',
    color: isActive(route) ? '#a5b4fc' : 'rgba(255,255,255,0.8)',
    fontWeight: isActive(route) ? 700 : 400,
    borderLeft: isActive(route) ? '3px solid #818cf8' : '3px solid transparent',
    transition: 'all 0.15s ease',
    '&:hover': { background: 'rgba(255,255,255,0.07) !important', color: '#fff' },
  });

  const activeSubItemSx = (route) => ({
    fontSize: '13px', py: 1.1, px: 2,
    display: 'flex', alignItems: 'center', gap: 1.5,
    borderRadius: '8px', mx: 0.8, my: 0.15,
    background: isActive(route) ? 'linear-gradient(90deg, rgba(99,102,241,0.25), rgba(139,92,246,0.15)) !important' : 'transparent',
    color: isActive(route) ? '#a5b4fc' : 'rgba(255,255,255,0.75)',
    fontWeight: isActive(route) ? 700 : 400,
    borderLeft: isActive(route) ? '3px solid #818cf8' : '3px solid transparent',
    transition: 'all 0.15s ease',
    '&:hover': { background: 'rgba(255,255,255,0.07) !important', color: '#fff' },
  });

  const nestedItemSx = (routes) => {
    const active = isAnyActive(routes);
    return {
      fontSize: '13.5px', py: 1.2, px: 2,
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      borderRadius: '8px', mx: 0.8, my: 0.2,
      background: active ? 'linear-gradient(90deg, rgba(99,102,241,0.25), rgba(139,92,246,0.15)) !important' : 'transparent',
      color: active ? '#a5b4fc' : 'rgba(255,255,255,0.8)',
      fontWeight: active ? 700 : 400,
      borderLeft: active ? '3px solid #818cf8' : '3px solid transparent',
      transition: 'all 0.15s ease',
      '&:hover': { background: 'rgba(255,255,255,0.07) !important', color: '#fff' },
    };
  };

  const isDriverRole = (roleName || '').toLowerCase() === 'driver';

  return (
    <>
      {/* ── Driver Role — Delivery Updates only ── */}
      {isDriverRole ? (
        <Paper sx={{
          position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1300,
          background: 'linear-gradient(180deg, #1a1f5e 0%, #141852 100%)',
          borderTop: '1px solid rgba(255,255,255,0.08)',
          boxShadow: '0 -4px 24px rgba(0,0,0,0.35)',
          paddingBottom: 'env(safe-area-inset-bottom)',
        }} elevation={0}>
          <BottomNavigation showLabels sx={{
            background: 'transparent', height: '62px',
            '& .MuiBottomNavigationAction-root': { color: 'rgba(255,255,255,0.45)', minWidth: '44px', padding: '6px 0 4px' },
            '& .MuiBottomNavigationAction-label': { fontSize: '9px', fontWeight: 600, marginTop: '3px' },
          }}>
            {/* Driver Dashboard */}
            <BottomNavigationAction label="Dashboard"
              icon={<Box sx={{ width: 36, height: 36, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: isActive('/DriverDashboard') ? 'linear-gradient(135deg,#f59e0b22,#ef444422)' : 'transparent', border: isActive('/DriverDashboard') ? '1px solid rgba(245,158,11,0.3)' : '1px solid transparent' }}>
                <Dashboard sx={{ fontSize: 20, color: isActive('/DriverDashboard') ? '#f59e0b' : 'rgba(255,255,255,0.45)' }} />
              </Box>}
              onClick={() => history.push('/DriverDashboard')}
              sx={{ color: isActive('/DriverDashboard') ? '#f59e0b !important' : 'rgba(255,255,255,0.45)' }}
            />
            {/* Onsite Exchange */}
            <BottomNavigationAction label="Exchange"
              icon={<Box sx={{ width: 36, height: 36, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: isActive('/ExchangeList') ? 'linear-gradient(135deg,#ea580c22,#f9731622)' : 'transparent', border: isActive('/ExchangeList') ? '1px solid rgba(234,88,12,0.3)' : '1px solid transparent' }}>
                <SwapHoriz sx={{ fontSize: 20, color: isActive('/ExchangeList') ? '#f97316' : 'rgba(255,255,255,0.45)' }} />
              </Box>}
              onClick={() => history.push('/ExchangeList')}
              sx={{ color: isActive('/ExchangeList') ? '#f97316 !important' : 'rgba(255,255,255,0.45)' }}
            />
            {/* COD */}
            <BottomNavigationAction label="COD"
              icon={<Box sx={{ width: 36, height: 36, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: isActive('/CODList') ? 'linear-gradient(135deg,#ea580c22,#f9731622)' : 'transparent', border: isActive('/CODList') ? '1px solid rgba(234,88,12,0.3)' : '1px solid transparent' }}>
                <LocalShipping sx={{ fontSize: 20, color: isActive('/CODList') ? '#f97316' : 'rgba(255,255,255,0.45)' }} />
              </Box>}
              onClick={() => history.push('/CODList')}
              sx={{ color: isActive('/CODList') ? '#f97316 !important' : 'rgba(255,255,255,0.45)' }}
            />
          </BottomNavigation>
        </Paper>
      ) : isExecutiveRole ? (
        <Paper sx={{
          position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1300,
          background: 'linear-gradient(180deg, #1a1f5e 0%, #141852 100%)',
          borderTop: '1px solid rgba(255,255,255,0.08)',
          boxShadow: '0 -4px 24px rgba(0,0,0,0.35)',
          paddingBottom: 'env(safe-area-inset-bottom)',
        }} elevation={0}>
          <BottomNavigation showLabels sx={{
            background: 'transparent', height: '62px',
            '& .MuiBottomNavigationAction-root': { color: 'rgba(255,255,255,0.45)', minWidth: '44px', padding: '6px 0 4px' },
          }}>
            {/* Dashboard */}
            <BottomNavigationAction label="Dashboard"
              icon={<Box sx={{ width: 36, height: 36, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: isActive('/SalesExecutiveDashboard') ? 'linear-gradient(135deg,#f59e0b22,#ef444422)' : 'transparent', border: isActive('/SalesExecutiveDashboard') ? '1px solid rgba(245,158,11,0.3)' : '1px solid transparent' }}>
                <Dashboard sx={{ fontSize: 20, color: isActive('/SalesExecutiveDashboard') ? '#f59e0b' : 'rgba(255,255,255,0.45)' }} />
              </Box>}
              onClick={() => history.push('/SalesExecutiveDashboard')}
              sx={{ color: isActive('/SalesExecutiveDashboard') ? '#f59e0b !important' : 'rgba(255,255,255,0.45)' }}
            />
            {/* Enquiries */}
            <BottomNavigationAction label="Enquiries"
              icon={<Box sx={{ width: 36, height: 36, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: isAnyActive(['/EnquiryIndex', '/EnquiryForm']) ? 'linear-gradient(135deg,#6366f122,#8b5cf622)' : 'transparent', border: isAnyActive(['/EnquiryIndex', '/EnquiryForm']) ? '1px solid rgba(99,102,241,0.3)' : '1px solid transparent' }}>
                <Assignment sx={{ fontSize: 20, color: isAnyActive(['/EnquiryIndex', '/EnquiryForm']) ? '#818cf8' : 'rgba(255,255,255,0.45)' }} />
              </Box>}
              onClick={() => history.push('/EnquiryIndex')}
              sx={{ color: isAnyActive(['/EnquiryIndex', '/EnquiryForm']) ? '#818cf8 !important' : 'rgba(255,255,255,0.45)' }}
            />
            {/* New Enquiry */}
            <BottomNavigationAction label="New"
              icon={<Box sx={{ width: 38, height: 38, borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg,#1e40af,#3b82f6)', boxShadow: '0 4px 12px rgba(30,64,175,0.5)' }}>
                <Add sx={{ fontSize: 22, color: '#fff' }} />
              </Box>}
              onClick={() => history.push('/EnquiryForm/create')}
              sx={{ color: '#3b82f6 !important' }}
            />
          </BottomNavigation>
        </Paper>
      ) : (
        <>
          <Paper
            sx={{
              position: 'fixed',
              bottom: 0, left: 0, right: 0,
              zIndex: 1300,
              background: 'linear-gradient(180deg, #1a1f5e 0%, #141852 100%)',
              borderTop: '1px solid rgba(255,255,255,0.08)',
              boxShadow: '0 -4px 24px rgba(0,0,0,0.35)',
              // iOS home indicator — adds padding below nav bar
              paddingBottom: 'env(safe-area-inset-bottom)',
            }}
            elevation={0}
          >
            <BottomNavigation
              showLabels
              sx={{
                background: 'transparent',
                height: '62px',
                '& .MuiBottomNavigationAction-root': {
                  color: 'rgba(255,255,255,0.45)',
                  minWidth: '44px',
                  padding: '6px 0 4px',
                  transition: 'all 0.2s ease',
                  '&.Mui-selected': { color: '#fff' },
                },
                '& .MuiBottomNavigationAction-label': {
                  fontSize: '9px',
                  fontWeight: 600,
                  letterSpacing: '0.3px',
                  marginTop: '3px',
                  transition: 'all 0.2s ease',
                },
              }}
            >
              {/* HOME */}
              <BottomNavigationAction
                label="Home"
                icon={
                  <Box sx={{
                    position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center',
                  }}>
                    {isActive('/Home') && (
                      <Box sx={{
                        position: 'absolute', top: -10, width: 28, height: 3,
                        borderRadius: '0 0 4px 4px',
                        background: 'linear-gradient(90deg, #f59e0b, #ef4444)',
                      }} />
                    )}
                    <Box sx={{
                      width: 36, height: 36, borderRadius: '12px', display: 'flex',
                      alignItems: 'center', justifyContent: 'center',
                      background: isActive('/Home')
                        ? 'linear-gradient(135deg, #f59e0b22, #ef444422)'
                        : 'transparent',
                      border: isActive('/Home') ? '1px solid rgba(245,158,11,0.3)' : '1px solid transparent',
                      transition: 'all 0.2s ease',
                    }}>
                      <Dashboard sx={{ fontSize: 20, color: isActive('/Home') ? '#f59e0b' : 'rgba(255,255,255,0.45)' }} />
                    </Box>
                  </Box>
                }
                onClick={() => history.push('/Home')}
                sx={{ color: isActive('/Home') ? '#f59e0b !important' : 'rgba(255,255,255,0.45)' }}
              />

              {/* MASTER */}
              {hasReadMasterPermission && (
                <BottomNavigationAction
                  label="Master"
                  icon={
                    <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {isMasterActive && (
                        <Box sx={{ position: 'absolute', top: -10, width: 28, height: 3, borderRadius: '0 0 4px 4px', background: 'linear-gradient(90deg, #10b981, #059669)' }} />
                      )}
                      <Box sx={{
                        width: 36, height: 36, borderRadius: '12px', display: 'flex',
                        alignItems: 'center', justifyContent: 'center',
                        background: isMasterActive ? 'linear-gradient(135deg, #10b98122, #05966922)' : 'transparent',
                        border: isMasterActive ? '1px solid rgba(16,185,129,0.3)' : '1px solid transparent',
                        transition: 'all 0.2s ease',
                      }}>
                        <Business sx={{ fontSize: 20, color: isMasterActive ? '#10b981' : 'rgba(255,255,255,0.45)' }} />
                      </Box>
                    </Box>
                  }
                  onClick={(e) => handleMenuOpen(e, 'master')}
                  sx={{ color: isMasterActive ? '#10b981 !important' : 'rgba(255,255,255,0.45)' }}
                />
              )}

              {/* TRANSACTION */}
              {hasReadMasterPermission && (
                <BottomNavigationAction
                  label="Txn"
                  icon={
                    <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {isTransactionActive && (
                        <Box sx={{ position: 'absolute', top: -10, width: 28, height: 3, borderRadius: '0 0 4px 4px', background: 'linear-gradient(90deg, #6366f1, #8b5cf6)' }} />
                      )}
                      <Box sx={{
                        width: 36, height: 36, borderRadius: '12px', display: 'flex',
                        alignItems: 'center', justifyContent: 'center',
                        background: isTransactionActive ? 'linear-gradient(135deg, #6366f122, #8b5cf622)' : 'transparent',
                        border: isTransactionActive ? '1px solid rgba(99,102,241,0.3)' : '1px solid transparent',
                        transition: 'all 0.2s ease',
                      }}>
                        <ShoppingCart sx={{ fontSize: 20, color: isTransactionActive ? '#818cf8' : 'rgba(255,255,255,0.45)' }} />
                      </Box>
                    </Box>
                  }
                  onClick={(e) => handleMenuOpen(e, 'transaction')}
                  sx={{ color: isTransactionActive ? '#818cf8 !important' : 'rgba(255,255,255,0.45)' }}
                />
              )}

              {/* ACCOUNTS */}
              {hasReadAccountsPermission && (
                <BottomNavigationAction
                  label="Accounts"
                  icon={
                    <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {isAccountsActive && (
                        <Box sx={{ position: 'absolute', top: -10, width: 28, height: 3, borderRadius: '0 0 4px 4px', background: 'linear-gradient(90deg, #06b6d4, #0891b2)' }} />
                      )}
                      <Box sx={{
                        width: 36, height: 36, borderRadius: '12px', display: 'flex',
                        alignItems: 'center', justifyContent: 'center',
                        background: isAccountsActive ? 'linear-gradient(135deg, #06b6d422, #0891b222)' : 'transparent',
                        border: isAccountsActive ? '1px solid rgba(6,182,212,0.3)' : '1px solid transparent',
                        transition: 'all 0.2s ease',
                      }}>
                        <AccountBalance sx={{ fontSize: 20, color: isAccountsActive ? '#22d3ee' : 'rgba(255,255,255,0.45)' }} />
                      </Box>
                    </Box>
                  }
                  onClick={(e) => handleMenuOpen(e, 'accounts')}
                  sx={{ color: isAccountsActive ? '#22d3ee !important' : 'rgba(255,255,255,0.45)' }}
                />
              )}

              {/* DELIVERY */}
              {!isDriverRole && !isExecutiveRole && (
                <BottomNavigationAction
                  label="Delivery"
                  icon={
                    <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {isDeliveryActive && (
                        <Box sx={{ position: 'absolute', top: -10, width: 28, height: 3, borderRadius: '0 0 4px 4px', background: 'linear-gradient(90deg, #ea580c, #f97316)' }} />
                      )}
                      <Box sx={{
                        width: 36, height: 36, borderRadius: '12px', display: 'flex',
                        alignItems: 'center', justifyContent: 'center',
                        background: isDeliveryActive ? 'linear-gradient(135deg, #ea580c22, #f9731622)' : 'transparent',
                        border: isDeliveryActive ? '1px solid rgba(234,88,12,0.3)' : '1px solid transparent',
                        transition: 'all 0.2s ease',
                      }}>
                        <LocalShipping sx={{ fontSize: 20, color: isDeliveryActive ? '#f97316' : 'rgba(255,255,255,0.45)' }} />
                      </Box>
                    </Box>
                  }
                  onClick={(e) => handleMenuOpen(e, 'delivery')}
                  sx={{ color: isDeliveryActive ? '#f97316 !important' : 'rgba(255,255,255,0.45)' }}
                />
              )}

              {/* DELIVERY UPDATEES */}
              {!isExecutiveRole && (
                <BottomNavigationAction
                  label="DeliveryUpdates"
                  icon={
                    <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {isDeliveryUpdatesActive && (
                        <Box sx={{ position: 'absolute', top: -10, width: 28, height: 3, borderRadius: '0 0 4px 4px', background: 'linear-gradient(90deg, #ea580c, #f97316)' }} />
                      )}
                      <Box sx={{
                        width: 36, height: 36, borderRadius: '12px', display: 'flex',
                        alignItems: 'center', justifyContent: 'center',
                        background: isDeliveryUpdatesActive ? 'linear-gradient(135deg, #ea580c22, #f9731622)' : 'transparent',
                        border: isDeliveryUpdatesActive ? '1px solid rgba(234,88,12,0.3)' : '1px solid transparent',
                        transition: 'all 0.2s ease',
                      }}>
                        <LocalShipping sx={{ fontSize: 20, color: isDeliveryUpdatesActive ? '#f97316' : 'rgba(255,255,255,0.45)' }} />
                      </Box>
                    </Box>
                  }
                  onClick={(e) => handleMenuOpen(e, 'delivery')}
                  sx={{ color: isDeliveryUpdatesActive ? '#f97316 !important' : 'rgba(255,255,255,0.45)' }}
                />
              )}

              {/* REPORTS */}
              {(hasReadReportsPermission || hasReadMasterPermission) && (
                <BottomNavigationAction
                  label="Reports" icon={
                    <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {isReportsActive && (
                        <Box sx={{ position: 'absolute', top: -10, width: 28, height: 3, borderRadius: '0 0 4px 4px', background: 'linear-gradient(90deg, #f472b6, #ec4899)' }} />
                      )}
                      <Box sx={{
                        width: 36, height: 36, borderRadius: '12px', display: 'flex',
                        alignItems: 'center', justifyContent: 'center',
                        background: isReportsActive ? 'linear-gradient(135deg, #f472b622, #ec489922)' : 'transparent',
                        border: isReportsActive ? '1px solid rgba(244,114,182,0.3)' : '1px solid transparent',
                        transition: 'all 0.2s ease',
                      }}>
                        <BarChart sx={{ fontSize: 20, color: isReportsActive ? '#f472b6' : 'rgba(255,255,255,0.45)' }} />
                      </Box>
                    </Box>
                  }
                  onClick={() => history.push('/ReportsHub')}
                  sx={{ color: isReportsActive ? '#f472b6 !important' : 'rgba(255,255,255,0.45)' }}
                />
              )}

              {/* MORE/SETTINGS */}
              <BottomNavigationAction
                label="More"
                icon={
                  <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    {isSettingsActive && (
                      <Box sx={{ position: 'absolute', top: -10, width: 28, height: 3, borderRadius: '0 0 4px 4px', background: 'linear-gradient(90deg, #94a3b8, #64748b)' }} />
                    )}
                    <Box sx={{
                      width: 36, height: 36, borderRadius: '12px', display: 'flex',
                      alignItems: 'center', justifyContent: 'center',
                      background: isSettingsActive ? 'linear-gradient(135deg, #94a3b822, #64748b22)' : 'transparent',
                      border: isSettingsActive ? '1px solid rgba(148,163,184,0.3)' : '1px solid transparent',
                      transition: 'all 0.2s ease',
                    }}>
                      <Settings sx={{ fontSize: 20, color: isSettingsActive ? '#cbd5e1' : 'rgba(255,255,255,0.45)' }} />
                    </Box>
                  </Box>
                }
                onClick={(e) => handleMenuOpen(e, 'settings')}
                sx={{ color: isSettingsActive ? '#cbd5e1 !important' : 'rgba(255,255,255,0.45)' }}
              />
            </BottomNavigation>
          </Paper>

          {/* Master Menu */}
          <Menu
            anchorEl={anchorEl}
            open={activeMenu === 'master'}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            PaperProps={{ sx: menuPaperSx }}
          >
            {/* Menu header */}
            <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.03)' }}>
              <Typography sx={{ fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', color: '#818cf8', textTransform: 'uppercase' }}>
                {masterSubMenu ? (masterSubMenu === 'accountMaster' ? 'Account Master' : masterSubMenu === 'masterSub' ? 'Master' : 'Product') : 'Master'}
              </Typography>
            </Box>

            {!masterSubMenu ? (
              menuItems.master.map((item, idx) => (
                <MenuItem
                  key={idx}
                  onClick={() => item.isNested ? setMasterSubMenu(item.subMenuKey) : handleNavigation(item.route)}
                  sx={item.route ? activeItemSx(item.route) : nestedItemSx(menuItems[item.subMenuKey]?.map(s => s.route) || [])}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
                    {item.icon && (
                      <Box sx={{
                        width: 28, height: 28, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        background: 'rgba(255,255,255,0.07)', flexShrink: 0,
                      }}>{item.icon}</Box>
                    )}
                    <span>{item.label}</span>
                  </Box>
                  {item.isNested && <ChevronRight sx={{ fontSize: 16, opacity: 0.5 }} />}
                </MenuItem>
              ))
            ) : (
              <>
                <MenuItem onClick={() => setMasterSubMenu(null)} sx={menuHeaderSx}>
                  <ArrowBack sx={{ fontSize: 16, color: '#818cf8' }} />
                  <span style={{ fontWeight: 600, fontSize: '13px' }}>Back</span>
                </MenuItem>
                {(menuItems[masterSubMenu] || []).map((item, idx) => (
                  <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeSubItemSx(item.route)}>
                    {item.icon && (
                      <Box sx={{ width: 28, height: 28, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.07)', flexShrink: 0 }}>
                        {item.icon}
                      </Box>
                    )}
                    {item.label}
                  </MenuItem>
                ))}
              </>
            )}
          </Menu>

          {/* Transaction Menu */}
          <Menu
            anchorEl={anchorEl}
            open={activeMenu === 'transaction'}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            PaperProps={{ sx: menuPaperSx }}
          >
            <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.03)' }}>
              <Typography sx={{ fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', color: '#818cf8', textTransform: 'uppercase' }}>
                {transactionSubMenu
                  ? transactionSubMenu === 'purchase' ? 'Purchase' : transactionSubMenu === 'sales' ? 'Sales' : transactionSubMenu === 'stock' ? 'Stock' : 'Production'
                  : 'Transaction'}
              </Typography>
            </Box>

            {!transactionSubMenu ? (
              <>
                {[
                  { key: 'purchase', label: 'Purchase', icon: <LocalShipping sx={{ fontSize: 15 }} />, routes: [...menuItems.transaction.purchase.entries.map(i => i.route), ...menuItems.transaction.purchase.reports.map(i => i.route)] },
                  { key: 'sales', label: 'Sales', icon: <ShoppingBag sx={{ fontSize: 15 }} />, routes: [...menuItems.transaction.sales.entries.map(i => i.route), ...menuItems.transaction.sales.reports.map(i => i.route)] },
                  { key: 'stock', label: 'Stock', icon: <CompareArrows sx={{ fontSize: 15 }} />, routes: [...menuItems.transaction.stock.entries.map(i => i.route), ...menuItems.transaction.stock.reports.map(i => i.route)] },
                ].map(cat => (
                  <MenuItem key={cat.key} onClick={() => setTransactionSubMenu(cat.key)} sx={nestedItemSx(cat.routes)}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Box sx={{ width: 28, height: 28, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.07)' }}>
                        {cat.icon}
                      </Box>
                      <span>{cat.label}</span>
                    </Box>
                    <ChevronRight sx={{ fontSize: 16, opacity: 0.5 }} />
                  </MenuItem>
                ))}
                <MenuItem onClick={() => handleNavigation('/ProductionIndex')} sx={nestedItemSx(menuItems.transaction.production.entries.map(i => i.route))}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box sx={{ width: 28, height: 28, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.07)' }}>
                      <PrecisionManufacturing sx={{ fontSize: 15 }} />
                    </Box>
                    <span>Production</span>
                  </Box>
                </MenuItem>
                <MenuItem onClick={() => handleNavigation('/EInvoiceIndex')} sx={activeItemSx('/EInvoiceIndex')}>
                  <Box sx={{ width: 28, height: 28, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.07)' }}>
                    <Receipt sx={{ fontSize: 15 }} />
                  </Box>
                  <span>E-Invoice</span>
                </MenuItem>
              </>
            ) : (
              <>
                <MenuItem onClick={() => setTransactionSubMenu(null)} sx={menuHeaderSx}>
                  <ArrowBack sx={{ fontSize: 16, color: '#818cf8' }} />
                  <span style={{ fontWeight: 600, fontSize: '13px' }}>Back</span>
                </MenuItem>
                {menuItems.transaction[transactionSubMenu].entries.map((item, idx) => (
                  <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeSubItemSx(item.route)}>
                    <Box sx={{ width: 28, height: 28, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.07)', flexShrink: 0 }}>
                      {item.icon}
                    </Box>
                    {item.label}
                  </MenuItem>
                ))}
                {menuItems.transaction[transactionSubMenu].reports && (
                  <>
                    <Box sx={{ mx: 1, my: 0.5 }}>
                      <Divider sx={{ borderColor: 'rgba(129,140,248,0.3)' }} />
                      <Typography sx={{ color: '#818cf8', px: 1, pt: 0.8, pb: 0.3, fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px' }}>
                        Reports
                      </Typography>
                    </Box>
                    {menuItems.transaction[transactionSubMenu].reports.map((item, idx) => (
                      <MenuItem key={`r-${idx}`} onClick={() => handleNavigation(item.route)} sx={activeSubItemSx(item.route)}>
                        <Box sx={{ width: 28, height: 28, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.07)', flexShrink: 0 }}>
                          {item.icon}
                        </Box>
                        {item.label}
                      </MenuItem>
                    ))}
                  </>
                )}
              </>
            )}
          </Menu>

          {/* Accounts Menu */}
          <Menu
            anchorEl={anchorEl}
            open={activeMenu === 'accounts'}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            PaperProps={{ sx: menuPaperSx }}
          >
            <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.03)' }}>
              <Typography sx={{ fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', color: '#22d3ee', textTransform: 'uppercase' }}>
                Accounts
              </Typography>
            </Box>
            {menuItems.accounts.map((item, idx) => (
              <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeItemSx(item.route)}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
                  {item.icon && (
                    <Box sx={{ width: 28, height: 28, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.07)', flexShrink: 0 }}>
                      {item.icon}
                    </Box>
                  )}
                  <span>{item.label}</span>
                </Box>
              </MenuItem>
            ))}
          </Menu>

          {/* Delivery Menu */}
          <Menu
            anchorEl={anchorEl}
            open={activeMenu === 'delivery'}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            PaperProps={{ sx: menuPaperSx }}
          >
            <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.03)' }}>
              <Typography sx={{ fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', color: '#f97316', textTransform: 'uppercase' }}>
                Delivery
              </Typography>
            </Box>
            {menuItems.delivery.map((item, idx) => (
              <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeItemSx(item.route)}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
                  <Box sx={{ width: 28, height: 28, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.07)', flexShrink: 0 }}>
                    {item.icon}
                  </Box>
                  <span>{item.label}</span>
                </Box>
              </MenuItem>
            ))}
          </Menu>

          {/* Delivery Updates Menu */}
          <Menu
            anchorEl={anchorEl}
            open={activeMenu === 'deliveryUpdates'}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            PaperProps={{ sx: menuPaperSx }}
          >
            <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.03)' }}>
              <Typography sx={{ fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', color: '#f97316', textTransform: 'uppercase' }}>
                Delivery Updates
              </Typography>
            </Box>
            {menuItems.deliveryUpdates.map((item, idx) => (
              <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeItemSx(item.route)}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
                  <Box sx={{ width: 28, height: 28, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.07)', flexShrink: 0 }}>
                    {item.icon}
                  </Box>
                  <span>{item.label}</span>
                </Box>
              </MenuItem>
            ))}
          </Menu>

          {/* Settings / More Menu */}
          <Menu
            anchorEl={anchorEl}
            open={activeMenu === 'settings'}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            PaperProps={{ sx: menuPaperSx }}
          >
            <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.03)' }}>
              <Typography sx={{ fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', color: '#cbd5e1', textTransform: 'uppercase' }}>
                More
              </Typography>
            </Box>
            {[
              { label: 'Users', route: '/UserIndex', icon: <PeopleAlt sx={{ fontSize: 15 }} /> },
              { label: 'Roles', route: '/RoleIndex', icon: <GroupWork sx={{ fontSize: 15 }} /> },
              { label: 'Reset Password', route: '/PasswordChange', icon: <Settings sx={{ fontSize: 15 }} /> },
            ].map((item, idx) => (
              <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeItemSx(item.route)}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
                  <Box sx={{ width: 28, height: 28, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.07)', flexShrink: 0 }}>
                    {item.icon}
                  </Box>
                  <span>{item.label}</span>
                </Box>
              </MenuItem>
            ))}
          </Menu>
        </> /* end non-executive nav */
      )} {/* end isExecutiveRole ternary */}
    </>
  );
};

export default MobileBottomNav;
